import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import InputField from "../../../components/inputfield/InputField";
import SelectBox from "../../../components/select box/SelectBox";
import "../../all css/contactus.css";
import "../../all css/interested.css";
import { enquire } from "../../../services/api";

function Intereseted(props) {
  const handleCloseDialogbox = () => {
    props.handleInterestedDialog(false);
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    term_cond: false,
  });

  const [study, setStudy] = useState("");
  const [destination, setDestination] = useState("");
  const [plan, setPlan] = useState("");

  const userDetails = useRef({
    plan_stude: "",
    study_level: "",
    destination: "",
  });

  async function handleSubmit(e) {
    e.preventDefault();
    props.handleInterestedDialog(false);

    let response = await enquire({
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      destination: userDetails?.current?.destination,
      plan_stude: userDetails?.current?.plan_stude,
      study_level: userDetails?.current?.study_level,
      term_cond: formData.term_cond,
    });

    if (response === "success") {
      setFormData({
        name: "",
        email: "",
        mobile: "",
        destination: "",
        plan_stude: "",
        study_level: "",
        term_cond: false,
      });
      // setAlertToggleModal(true);
      // setTimeout(() => {
      //   setAlertToggleModal(false);
      // }, 2000);
    }
  }
  return (
    <>
      <div className="contact_us_main_container">
        <div className="contact_us_under_main_container">
          <form onSubmit={handleSubmit}>
            <div className="acc_details_main_contianer">
              <InputField
                headTextInput="Name"
                inputType="text"
                placeholderText="Enter Name"
                inputId="accEmail"
                value={formData.name}
                name="accEmail"
                onChange={(e) =>
                  setFormData((preVal) => ({
                    ...preVal,
                    name: e.target.value,
                  }))
                }
              />

              <InputField
                headTextInput="Email"
                inputType="text"
                value={formData.email}
                placeholderText="Enter email"
                inputId="accEmail"
                name="accEmail"
                onChange={(e) =>
                  setFormData((preVal) => ({
                    ...preVal,
                    email: e.target.value,
                  }))
                }
              />

              <label className="input_label_text">Phone number</label>
              <div className="contact_us_input_container">
                <div className="input_field_container">
                  <input
                    type="number"
                    placeholder="Enter number"
                    autoComplete="off"
                    value={formData.mobile}
                    required
                    className="input_dialog_style"
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        mobile: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>

              <div className="spacing_container" />

              <SelectBox
                headTextInput="Choose your preferred study destination ?"
                initialValue="Select country"
                value={formData.destination}
                options={[
                  { optionName: "USA", optionValue: "USA" },
                  { optionName: "Canada", optionValue: "Canada" },
                  { optionName: "Australia", optionValue: "Australia" },
                  {
                    optionName: "United Kingdom",
                    optionValue: "United Kingdom",
                  },
                  { optionName: "Dubai", optionValue: "Dubai" },
                  { optionName: "Germany", optionValue: "Germany" },
                ]}
                selectValue={(e) => {
                  userDetails.current["destination"] = e;
                }}
              />

              <SelectBox
                headTextInput="When do you plan to study ?"
                initialValue="Select year"
                value={formData.plan_stude}
                options={[
                  { optionName: "2022", optionValue: "2022" },
                  { optionName: "2023", optionValue: "2023" },
                  { optionName: "2024", optionValue: "2024" },
                  { optionName: "2025", optionValue: "2025" },
                  { optionName: "2026", optionValue: "2026" },
                  { optionName: "2027", optionValue: "2027" },
                ]}
                selectValue={(e) => {
                  userDetails.current["plan_stude"] = e;
                }}
              />

              <SelectBox
                headTextInput="Preferred study level "
                initialValue="Select your level"
                value={formData.study_level}
                options={[
                  { optionName: "Diploma", optionValue: "Diploma" },
                  {
                    optionName: "Graduate Certificate",
                    optionValue: "Graduate Certificate",
                  },
                  { optionName: "Bachelors", optionValue: "Bachelors" },
                  {
                    optionName: "Integrated Programme",
                    optionValue: "Integrated Programme",
                  },
                  { optionName: "Masters", optionValue: "Masters" },
                  { optionName: "PHD", optionValue: "PHD" },
                ]}
                selectValue={(e) => {
                  userDetails.current["study_level"] = e;
                  // setStudy(e);
                }}
              />

              <div className="checkbox_label_container">
                <input
                  type="checkbox"
                  id="check1"
                  value={formData.term_cond}
                  name="check"
                  className="checkbox_self"
                  required
                  onChange={(e) =>
                    setFormData((preVal) => ({
                      ...preVal,
                      term_cond: !formData.term_cond,
                    }))
                  }
                />
                <label htmlFor="check1" className="checkbox_label">
                  I agree to{" "}
                  <Link to="/TermsAndConditions" className="link_text_terms">
                    terms & conditions
                  </Link>
                </label>
              </div>
            </div>

            <div className="two_btn_container_interested">
              <button
                className="submit_btn_contact_us"
                onClick={handleCloseDialogbox}
              >
                Cancel
              </button>

              <div className="submit_btn_container">
                <button className="submit_btn_contact_us">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Intereseted;
